import { Exit, Player } from "../objects";
import levelGoalKit from "./levelGoalKit";

class Level15 extends levelGoalKit {
  constructor() {
    super();
    this.name = "The catacomb";
    this.diamondsGoal = 15;
  }

  get id() {
    return this.constructor.key
  }

  onInteractWith(el) {
    super.onInteractWith(el)
    
    if (el.isClass(Exit)) {
      this.onComplete();
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }

  }

}

Level15.key = 'level_15'
export default Level15;
